import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowRight, MessageCircle } from "lucide-react";

export const CompletionPage = () => {
  const location = useLocation();
  const { type } = location.state || { type: "formulaire" };

  const isPaiement = type === "paiement";

  return (
    <div
      className="min-h-screen bg-[#EAE8E4] font-sans antialiased flex flex-col items-center justify-center px-4 py-16"
      data-testid="completion-page"
    >
      <div className="w-full max-w-md space-y-8 text-center">

        {/* Logo */}
        <Link to="/" className="inline-flex flex-col items-center group mb-2">
          <img
            src="/assets/logo.png"
            alt="Hafani"
            className="h-10 w-auto object-contain transition-transform group-hover:scale-105"
          />
          <span className="text-[9px] text-emerald-700 font-medium mt-0.5 tracking-wide">
            Hafani, une solution pensée pour notre fin
          </span>
        </Link>

        {/* Icon */}
        <div className="flex justify-center">
          <div className="h-20 w-20 rounded-full bg-emerald-100 flex items-center justify-center ring-8 ring-emerald-50">
            <CheckCircle2 className="h-10 w-10 text-emerald-600" />
          </div>
        </div>

        {/* Title + body */}
        <div className="space-y-3">
          <h1
            className="font-serif text-4xl sm:text-5xl text-slate-900 leading-tight"
            data-testid="completion-title"
          >
            {isPaiement ? (
              <>Cotisation <em className="not-italic text-emerald-700">enregistrée.</em></>
            ) : (
              <>Demande <em className="not-italic text-emerald-700">reçue.</em></>
            )}
          </h1>
          <p
            className="text-slate-500 font-light leading-relaxed text-base"
            data-testid="completion-description"
          >
            {isPaiement
              ? "Merci pour votre contribution à la solidarité Hafani. Vous recevrez un récapitulatif par email."
              : "L'équipe Hafani pourra valider votre adhésion et revenir vers vous si nécessaire."}
          </p>
          <p
            className="text-sm text-slate-400 font-light"
            data-testid="completion-next-steps"
          >
            Vous pouvez consulter votre tableau de bord ou nous contacter si vous avez des questions.
          </p>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button
            asChild
            className="bg-slate-900 hover:bg-emerald-800 text-white rounded-full px-7 py-5 text-sm font-medium tracking-wide transition-all duration-300 group"
            data-testid="completion-home-button"
          >
            <Link to="/dashboard">
              Mon espace
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-slate-300 text-slate-700 hover:bg-white hover:border-slate-400 px-7 py-5 text-sm font-medium transition-all duration-300"
            data-testid="completion-contact-button"
          >
            <Link to="/contact">
              <MessageCircle className="mr-2 h-4 w-4" />
              Contacter Hafani
            </Link>
          </Button>
        </div>

      </div>

      <footer className="absolute bottom-6">
        <p className="text-xs text-slate-400 font-light">
          &copy; {new Date().getFullYear()} Hafani Management and Solutions
        </p>
      </footer>
    </div>
  );
};
